export const columns = [
  {
    title: 'page_tenant_operation',
    key: 'action',
    fixed: 'left',
    width: 80,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'page_system_coding_rules',
    dataIndex: 'codeRuleId',
    key: 'codeRuleId',
    ellipsis: true,
  },
  {
    title: 'page_product_code',
    dataIndex: 'code',
    key: 'code',
    // fixed: 'left',
    ellipsis: true,
    // scopedSlots: { customRender: 'code' }
    // width: 150
  },
  {
    title: 'page_product_name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
  },
  {
    title: 'page_product_specification_and_model',
    dataIndex: 'standardModel',
    key: 'standardModel',
    ellipsis: true,
  },
  {
    title: 'page_product_supplier',
    dataIndex: 'supplier',
    key: 'supplier',
    ellipsis: true,
  },
  {
    title: 'page_product_replaceSupplier',
    dataIndex: 'replaceSupplier',
    key: 'replaceSupplier',
    ellipsis: true,
  },
  {
    title: 'page_product_materialCode',
    dataIndex: 'materialCode',
    key: 'materialCode',
    ellipsis: true,
  },
  {
    title: 'page_product_replaceCodes',
    dataIndex: 'replaceCodes',
    key: 'replaceCodes',
    ellipsis: true,
  },
  {
    title: 'page_product_unit',
    dataIndex: 'unit',
    key: 'unit',
    width: 80,
    ellipsis: true,
  },
  /*{
    title: 'page_business_data_product_type',
    dataIndex: 'typeId',
    ellipsis: true,
    scopedSlots: { customRender: 'productType' }
  },*/
  {
    title: 'page_product_cutterCode',
    dataIndex: 'cutterCode',
    key: 'cutterCode',
    ellipsis: true,
  },
  {
    title: 'page_product_moldCode',
    dataIndex: 'moldCode',
    key: 'moldCode',
    ellipsis: true,
  },
  {
    title: 'page_product_description',
    dataIndex: 'description',
    key: 'description',
    ellipsis: true,
  }
]

export const processPathColumns = [
  {
    title: 'page_tenant_operation',
    dataIndex: 'action',
    key: 'action',
    width: 100,
    fixed: 'left',
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'page_product_process_sequence',
    dataIndex: 'sort',
    key: 'sort',
    width: 100,
    scopedSlots: { customRender: 'sort' }
  },
  {
    title: 'page_product_process_no',
    dataIndex: 'code',
    key: 'code',
    width: 200,
    scopedSlots: { customRender: 'code' }
  },
  {
    title: 'page_product_process_name',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: 'page_product_program_name',
    dataIndex: 'programName',
    key: 'programName',
    width: 210,
    scopedSlots: { customRender: 'programName' }
  },
  {
    title: 'page_product_standard_time',
    dataIndex: 'standardTime',
    key: 'standardTime',
    width: 230,
    scopedSlots: { customRender: 'standardTime' }
  }
]
